<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="工单号"><el-input v-model="query.code" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item label="物料"><el-input v-model="query.materialCode" size="small" clearable style="width:140px" /></el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('plm:plmPilotOrder:list')" type="primary" size="small" @click="search">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="pageList" border v-loading="loading" :header-cell-style="headStyle">
      <template slot="empty">暂无试制工单，请在 NPI 项目中下推试制工单</template>
      <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
      <el-table-column prop="code" label="工单号" min-width="130" header-align="center" align="left" />
      <el-table-column prop="materialCode" label="物料编码" min-width="120" header-align="center" align="left" />
      <el-table-column prop="quantity" label="计划数量" width="100" header-align="center" align="right" />
      <el-table-column prop="orderStatus" label="状态" width="90" header-align="center" align="center">
        <template slot-scope="scope">{{ orderStatusLabel(scope.row.orderStatus) }}</template>
      </el-table-column>
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" @size-change="s => { pageSize = s; pageIndex = 1 }" @current-change="p => { pageIndex = p }" />
  </div>
</template>

<script>
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

export default {
  name: 'PlmPilotOrder',
  data() {
    return {
      query: { code: '', materialCode: '' },
      list: [], pageIndex: 1, pageSize: 10, loading: false, permCodes: [],
      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' }
    }
  },
  computed: {
    filtered() {
      return this.list.filter(row => this.has(row.code, this.query.code) && this.has(row.materialCode, this.query.materialCode))
    },
    total() { return this.filtered.length },
    pageList() { return this.filtered.slice((this.pageIndex - 1) * this.pageSize, this.pageIndex * this.pageSize) }
  },
  created() { this.loadPerms(); this.load() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    has(value, keyword) {
      const text = String(keyword || '').trim().toLowerCase()
      if (!text) return true
      return String(value || '').toLowerCase().indexOf(text) >= 0
    },
    orderStatusLabel(s) {
      const map = { '0': '草稿', '1': '已下达', '3': '已完工', '4': '已关闭' }
      return map[s] || s
    },
    search() { this.pageIndex = 1; this.load() },
    load() {
      this.loading = true
      request.get('/plm/pilot/list').then(res => { this.list = res.data || [] }).catch(() => { this.list = [] }).finally(() => { this.loading = false })
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 12px; text-align: right; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
</style>
